import React from 'react';
import classes from './AuthLayout.module.scss';

const AuthLayout = ({children, headerSpacing}) => {
    return (
        <div className={`${classes['auth-layout']} ${classes['header-spacing']}`}>
            {children}
        </div>
    );
};

export default AuthLayout;